export default __webpack_public_path__ + "static/loira-casas-1471faeff674fa7e08fc1e8901a2d6db.jpg";